import React from 'react';

const Titulo = (props) => {  
    return (
        <div className="row">
            <div className="col-xs-12">
                <h1>
                    Confirmación de Solicitud para {props.titulo}
                </h1>
            </div>
            <div className="col-xs-12">
                <label className="label-primary">Antes de confirmar, chequear todos los datos de acuerdo a la organización, {props.entidadTipo}.</label>
            </div>
        </div>
    );
}

export default Titulo;